import { render, staticRenderFns } from "./FeaturedProducts.vue?vue&type=template&id=5aa1da58"
import script from "./FeaturedProducts.vue?vue&type=script&lang=js"
export * from "./FeaturedProducts.vue?vue&type=script&lang=js"
import style0 from "./FeaturedProducts.vue?vue&type=style&index=0&id=5aa1da58&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports